import { useStepSubmit } from '../../context/StepSubmitContext'

export default function StepErrorSummary() {
  const { errorCount, pulseKey, focusFirstError } = useStepSubmit()
  if (!errorCount || errorCount <= 0) return null
  const label =
    errorCount === 1
      ? '1 field needs attention'
      : `${errorCount} fields need attention`
  return (
    <button
      type="button"
      key={pulseKey}
      className="step-error-summary"
      onClick={focusFirstError}
      aria-label={label}
    >
      <span className="step-error-summary-dot" aria-hidden="true" />
      {label}
    </button>
  )
}
